import type { ValidationError } from '../../types/game';

interface ValidationBannerProps {
  errors: ValidationError[];
}

export function ValidationBanner({ errors }: ValidationBannerProps) {
  if (errors.length === 0) return null;

  return (
    <div className="flex flex-col gap-1.5 p-3 rounded border border-mafia-crimson/40 bg-mafia-crimson/10 mb-4">
      {errors.map((error) => (
        <div key={error.code} className="flex items-start gap-2">
          <span className="text-mafia-crimson text-sm leading-none mt-0.5 shrink-0">✕</span>
          <span className="text-xs text-red-300 leading-snug">
            {error.message}
            {error.affectedSeats.length > 0 && (
              <span className="ml-1 text-mafia-crimson/70">
                (места: {error.affectedSeats.join(', ')})
              </span>
            )}
          </span>
        </div>
      ))}
    </div>
  );
}
